var map = {
	"./Authentication.vue": [
		7256,
		7256
	],
	"./CreateNewCustomer.vue": [
		7677,
		3885,
		7677
	],
	"./CreateNewCustomerAddress.vue": [
		4587,
		3885,
		4587
	],
	"./History.vue": [
		6010,
		6624,
		6767
	],
	"./Kiosk.vue": [
		3372,
		3372
	],
	"./Login.vue": [
		8405,
		8405
	],
	"./LoginStaff.vue": [
		1490,
		1490
	],
	"./Logout.vue": [
		1518,
		1518
	],
	"./Nonpackage.vue": [
		810,
		810
	],
	"./NotFoundPage.vue": [
		9829,
		9829
	],
	"./Payment.vue": [
		5725,
		8106
	],
	"./Product.vue": [
		48,
		48
	],
	"./PublicCustomerInfo.vue": [
		3427,
		3427
	],
	"./Questionnaire.vue": [
		4517,
		4517
	],
	"./QuotationEdit.vue": [
		9432,
		3885,
		9432
	],
	"./QuotationView.vue": [
		1886,
		2489,
		1886
	],
	"./RenewalView.vue": [
		6374,
		6374
	],
	"./Report.vue": [
		5248,
		5248
	],
	"./Sme.vue": [
		534,
		534
	],
	"./Sme360.vue": [
		4664,
		4664
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5858;
module.exports = webpackAsyncContext;